import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';

// Create
export const createPfEmployee = createAsyncThunk(
  'pfEmployee/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/pf-employee', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create PF employee');
    }
  }
);

// Get All
export const fetchAllPfEmployees = createAsyncThunk(
  'pfEmployee/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/pf-employee');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF employees');
    }
  }
);

// Get By ID
export const fetchPfEmployeeById = createAsyncThunk(
  'pfEmployee/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/pf-employee/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF employee');
    }
  }
);

// Update
export const updatePfEmployee = createAsyncThunk(
  'pfEmployee/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/pf-employee/${id}`, data);
      return { id, data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update PF employee');
    }
  }
);

// Delete
export const deletePfEmployee = createAsyncThunk(
  'pfEmployee/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/pf-employee/${id}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to delete PF employee');
    }
  }
);
